import { GetTranscriptUrlRequest, GetTranscriptUrlResponse } from '@eigtech/meetings-types'
import type { IndexedMeetingTranscript } from '@eigtech/search-types'
import { contextualGet, genericGet, queryOptions, useQuery } from '@eigtech/ui-shared-api'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

async function getMeetingTranscript({ entityId, meetingId }: GetTranscriptUrlRequest) {
  const { url } = await contextualGet<GetTranscriptUrlResponse>(
    `${meetingsBasePath}/transcripts/${entityId}/${meetingId}`
  )
  const transcript = await genericGet<IndexedMeetingTranscript>(url)
  return transcript
}

export const getMeetingTranscriptQueryOptions = ({
  entityId,
  meetingId,
}: GetTranscriptUrlRequest) =>
  queryOptions({
    queryKey: meetingsQueryKeys.transcript({ entityId, meetingId }),
    queryFn: () => getMeetingTranscript({ entityId, meetingId }),
    enabled: !!(entityId && meetingId),
  })

export const useGetMeetingTranscript = (request: GetTranscriptUrlRequest) =>
  useQuery(getMeetingTranscriptQueryOptions(request))
